<template>
  <div class="home">
    <mynav1_en :data='nvdata'></mynav1_en>
    <div id="scsp1">
      “Smart Cash Register”Solution
    </div>
    <div id="scsp2">
      <div>Smart Cash Register Payment System</div>
      <div>Smart Cash Register Payment System integrates multiple functions and specifically for cash registers from the needs of customers.The cash register terminal adopts Android smart operating system with an embedded smart cash register kit, which is an ideal choice for retail, hotels, restaurants and entertainment application scenarios.</div>
    </div>
    <div id="scsp3">
      <h5>Feature</h5>
      <div v-for="item in p3data" :key="item">
        <i class="el-icon-caret-right"></i>{{item}}
      </div>
      <h5>Application scenarios</h5>
      <h5>Our services</h5>
    </div>
    <div id="scsp4">

    </div>
    <footer_en :data='ftdata'></footer_en>
  </div>
</template>

<style>
  #scsp1 {
    height: 8.98rem;
    background-image: url('../assets/pic/solve/cash/p1.jpg');
    background-size: 100% 100%;
    text-align: center;
    font-size: .72rem;
    font-weight: 400;
    color: #FFFFFF;
    padding-top: 3.92rem;
    box-sizing: border-box;
  }
  #scsp2 {
    height: 14.67rem;
    background-image: url('../assets/pic/solve/cash/p2.jpg');
    background-size: 100% 100%;
    overflow: hidden;
    text-align: center;
  }
  #scsp2 div {
    /* width: 11.47rem; */
    margin: 0 auto;
  }
  #scsp2 div:nth-child(1) {
    margin-top: 1.98rem;
    font-size: .46rem;
    font-weight: 800;
    color: #666666;
  }
  #scsp2 div:nth-child(2) {
    padding-bottom: .68rem;
    border-bottom: .02rem solid #D9D9D9;
    margin-top: .53rem;
    font-size: .28rem;
    font-weight: 500;
    color: #4D4D4D;
    box-sizing: border-box;
    text-align: left;
    width: 10.57rem;
    white-space: normal;
  }
  #scsp3 {
    height: 19.8rem;
    background-image: url('../assets/pic/solve/cash/p3.png');
    background-size: 100% 100%;
    padding-left: 3.71rem;
    overflow: hidden;
  }
  #scsp3 h5 {
    margin: 0;
    font-size: .46rem;
    font-weight: 800;
    color: #666666;
  }
  #scsp3 h5:nth-child(1) {
    margin-top: 1.38rem;
    margin-bottom: .82rem;
  }
  #scsp3 div {
    font-size: .28rem;
    font-weight: 500;
    color: #4D4D4D;
    margin-bottom: .32rem;
  }
  #scsp3 i {
    font-size: .2rem;
    vertical-align: middle;
    margin-right: .08rem;
  }
  #scsp3 h5:nth-child(6) {
    margin-top: .54rem;
  }
  #scsp3 h5:nth-child(7) {
    margin-top: 3.92rem;
  }
  #scsp4 {
    height: 18.55rem;
    background-image: url('../assets/pic/solve/cash/p4.png');
    background-size: 100% 100%;
  }
</style>

<script>
// @ is an alias to /src
require('@/assets/zt.css')
import mynav1_en from '@/components/mynav1_en'
import footer_en from '@/components/footer_en'


export default {
  components: {
    mynav1_en,footer_en
  },
  data () {
    return {
      p3data: [
        'Adopt modular design, stylish appearance, in line with modern aesthetic design;',
        'Abundant peripheral interfaces, supporting different types of financial external devices;',
        'Provide a complete API interface access protocol for external devices;',
        'Provide customized SAAS and ERP platform software solutions;'
      ],
      ovscroll: false,
      scrdist: 0,
      ftdata: {
        type: 'product',
        lcallback: () => {
          this.init()
        }
      },
      nvdata: {
        sindex: 1,
        type: 'solution',
        lcallback: (stype,sstype) => {
          this.setHead(stype,sstype)
        }
      }
   
    }
  },
  computed: {
  
  },
  methods: {

    onPageScroll (dist) {
      this.ovscroll = dist>93?true:false
      if (dist - this.scrdist > 93) {
        this.scrdist = dist
      } else if (dist < this.scrdist) {
        this.scrdist = dist
      }
      if (dist>0) this.ismenu=false
    },
    setRem() {
        var html = document.querySelector('html');
        var width = html.getBoundingClientRect().width;
        html.style.fontSize = width/20 + 'px'; /// 20
    },
    initWindowEv () {
      /// rem=px/2/14
      window.addEventListener('orientationchange', this.setRem);
      window.addEventListener('resize', this.setRem);
      this.setRem()

      var _this = this
      // var index = 1
      window.onscroll = function (e) {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        _this.onPageScroll(scrollTop)
      }
    },
  
    init () {
      var stype = this.$route.query.stype?this.$route.query.stype:''
      this.setHead(stype)
    }
  },
  mounted () {
    this.initWindowEv()
    this.init()
  }
}
</script>
